export enum CustomMaterialType {
    AnodizedAluminum = 'AnodizedAluminum',
    PowderCoated = 'PowderCoated',
    GalvanizedSteel = 'GalvanizedSteel',
}

export const materialMap: {[key: string]: CustomMaterialType} = {
    "Anodized": CustomMaterialType.AnodizedAluminum,
    "Powder Coated": CustomMaterialType.PowderCoated,
    "Galvanized": CustomMaterialType.GalvanizedSteel,
}